import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { getFile } from '../services/storeServices';

import Card from './Card';
import AppIcon from './AppIcon';
import Text from './Text';
import LinkButton from './LinkButton';

import AndroidIcon from '../assets/svg/android.svg';
import AppleIcon from '../assets/svg/apple.svg';

const OsIcon = styled.img`
  width: ${({ theme: { units } }) => units.sizes.ELEMENT_SMALL};
  margin: 0 auto;
`;

interface AppCardProps {
  icon: string,
  appName: string,
  so: string,
  description: string,
  id: string,
  versions: any,
}

function AppCard({
  icon, appName, so,
  description,
  id, versions,
}: AppCardProps) {

  const history = useHistory();
  const lastVersion = versions[0] ? versions[versions.length - 1] : {};

  const handleDownload = async () => {
    if (!lastVersion.file_url) return
    // const url = await getFile(lastVersion.file_url).then(url => url);
    const url = lastVersion.file_url;
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  console.log(navigator);

  return (
    <Card className="appcard-component">
      <AppIcon
        size="xlarge"
        icon={icon}
        appName={appName}
      />
      <Text placement="center" level="h3">
        { appName }
      </Text>
      <OsIcon
        src={so === 'android' ? AndroidIcon : AppleIcon}
      />
      <Text textColor="soft">
        { description }
      </Text>
      <div style={{ display: 'flex', flexFlow: 'row', justifyContent: 'space-around' }}>
        <LinkButton
          onClick={() => handleDownload()}
          disabled={!lastVersion.file_url}
        >
          Última versión
        </LinkButton>

        <LinkButton
          onClick={() => history.push(`/store/app/${id}`)}
          disabled={!lastVersion.file_url}
          flat
          textColor="highlight"
        >
          Ver más
        </LinkButton>
      </div>
    </Card>
  );
}

export default memo(AppCard);

AppCard.defaultProps = {
  icon: null,
  appName: null,
  so: 'android',
  description: null,
  id: null,
  versions: [],
}
